import { input, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  templateUrl: './dialog-footer.html',
  styleUrl: './dialog-footer.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dialog-footer',
    '[class]': '"dialog-footer_" + justifyContent()',
  },
})
export class DialogFooter {
  readonly justifyContent = input<'space-between' | 'center' | 'start' | 'end'>('end');
}
